module.exports = __webpack_public_path__ + "img/icon-banking-and-coverage.a591108a.svg";